import AlertIcon from './component'

export default AlertIcon